import { render, staticRenderFns } from "./NodeInvolvement.vue?vue&type=template&id=76031948&scoped=true&"
import script from "./NodeInvolvement.vue?vue&type=script&setup=true&lang=js&"
export * from "./NodeInvolvement.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76031948",
  null
  
)

export default component.exports